import type { ModalDialogButtonSetting } from '@myosh/odin-components';
import { Dialog } from '@myosh/odin-components';
import type { ReactElement } from 'react';
import { isValidElement, useMemo } from 'react';

type ButtonProps = {
  onHideModal: (closeReason?: string) => void;
  onDiscard: () => void;
};
interface ConfirmationWindowProps {
  onSaveHandler: () => void;
  showWindow: boolean;
  title: string;
  text: string | ReactElement;
  save: string;
  discard: string;
  onDiscardChanges: ButtonProps;
}

const ConfirmationWindow = ({
  onSaveHandler,
  showWindow: showSaveModal,
  text,
  title,
  discard,
  save,
  onDiscardChanges,
}: ConfirmationWindowProps) => {
  const dialogButtons: ModalDialogButtonSetting[] = useMemo(() => {
    return [
      {
        type: 'primary',
        name: save,
        text: save,
        onClick: onSaveHandler,
      },
      {
        type: 'default',
        variant: 'regular',
        name: discard,
        text: discard,
        onClick: onDiscardChanges.onDiscard,
      },
    ];
  }, [onDiscardChanges, onSaveHandler, save, discard]);

  return (
    <Dialog buttons={dialogButtons} header={title} visible={showSaveModal} onClose={onDiscardChanges.onHideModal}>
      {isValidElement(text) ? text : <div>{text}</div>}
    </Dialog>
  );
};

export default ConfirmationWindow;
